import { withTranslation } from "react-i18next";
import { Collapse } from "react-bootstrap";
import styled from "styled-components";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const COLORS = {
  background: "#ffffff",
  grid: "#f1f5f9",
  gradient: "#38bdf8",
  legends: "#64748b",
  stroke: "#0284c7",
};

const ChartCard = styled.div`
  background: ${COLORS.background};
  border-radius: 12px;
  padding: 20px;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.04),
    0 1px 2px rgba(0, 0, 0, 0.02);
  margin-bottom: 20px;
  border: 1px solid ${COLORS.grid};
`;

const ChartTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.legends};
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  display: block;
`;

const PowerAreaChart = (props) => {
  const { data, opened, t } = props;
  return (
    <Collapse in={opened}>
      {!data.length ? (
        <div>
          <ChartTitle>{t("No Data")}</ChartTitle>
        </div>
      ) : (
        <ChartCard>
          <div>
            <ChartTitle>{t("Power")}</ChartTitle>
          </div>
          <ResponsiveContainer width="100%" height={260}>
            <AreaChart
              data={data}
              margin={{ top: 10, right: 10, left: -20, bottom: 0 }}
            >
              <defs>
                <linearGradient id="powerGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop
                    offset="5%"
                    stopColor={COLORS.gradient}
                    stopOpacity={0.7}
                  />
                  <stop
                    offset="95%"
                    stopColor={COLORS.gradient}
                    stopOpacity={0.0}
                  />
                </linearGradient>
              </defs>

              {/* Soft horizontal grid lines only */}
              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
                stroke={COLORS.grid}
              />

              {/* Clean axes without bounding lines */}
              <XAxis
                dataKey="time"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: COLORS.legends }}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: COLORS.legends }}
              />

              <Tooltip formatter={(v, n) => [v, t("Power")]} />

              {/* Smooth area series with brand colors */}
              <Area
                type="monotone"
                dataKey="power"
                unit="kW"
                stroke={COLORS.stroke}
                strokeWidth={2.5}
                fillOpacity={1}
                fill="url(#powerGradient)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </ChartCard>
      )}
    </Collapse>
  );
};

export default withTranslation()(PowerAreaChart);
